export default "__VITE_ASSET__Wnz9D$kD__"